import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import messages from "components/messagesDescription";

const Breadcrumb = ({ categoryTags, intl, pageLabel }) => {
  return (
    <div className="breadcrumb">
      <span>
        <Link to={`/marketplace`}>{intl.formatMessage(messages.marketplace.marketplaceLabel)}</Link>{" "}
      </span>
      {categoryTags && categoryTags.length > 0 && <span>&gt; </span>}
      {categoryTags &&
        categoryTags.length > 0 &&
        categoryTags.map((tag, index) => (
          <span key={tag.categoryId}>
            {pageLabel ? (
              <Link to={`/marketplace/category/${tag.categoryId}`}>
                {intl.formatMessage({
                  id: tag.categoryName,
                  defaultMessage: tag.categoryName,
                })}
              </Link>
            ) : (
              intl.formatMessage({
                id: tag.categoryName,
                defaultMessage: tag.categoryName,
              })
            )}
            {index < categoryTags.length - 1 ? "," : ""}
          </span>
        ))}
      {pageLabel && <span>&gt; </span>}
      <span>{pageLabel}</span>
    </div>
  );
};

Breadcrumb.propTypes = {
  categoryTags: PropTypes.array,
  intl: PropTypes.object,
  pageLabel: PropTypes.string,
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./components/marketplace/Breadcrumb.jsx